itsoftApp.createModule("scrollActions", function () {
    var module = this;
    var queue = [];
    var loadingStarted = false;
    var moduleInitialized = false;
    var registeredPlugin = false;
    var headerHeight = itsoftApp.utils.getHeaderHeight();

    itsoftApp.modules.windowResize.addEvent(function () {
        headerHeight = itsoftApp.utils.getHeaderHeight();
    });

    var initScrollActions = function (element) {

        if (!registeredPlugin) {
            registeredPlugin = true;
            // регистрируем дополнительный плагин, чтобы анимации работали при скролле
            gsap.registerPlugin(ScrollTrigger);
        }

        if (typeof element === "function") {
            element();
        } else {
            if (element.classList.contains("js-scroll-text-start")) {
                var firstEnterFlag = false;

                gsap.utils.toArray(".js-scroll-text").forEach(function (item, i, arr) {
                    const els = item.querySelectorAll(".js-ordered-anim");

                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        onEnter: function () {
                            gsap.utils.toArray(els).forEach(function (el, i) {
                                setTimeout(function () {
                                    el.classList.add("fadeInShow");
                                    el.classList.add("js-anim-active");
                                    if (!firstEnterFlag && i === els.length - 1) {
                                        if (el.classList.contains("js-number-section")) {
                                            setTimeout(function () {
                                                gsap.utils.toArray(els).forEach(function (numEl, j) {
                                                    numEl.classList.add("js-visible");
                                                    itsoftApp.modules.numbersAnimate.init(numEl);
                                                });
                                            });
                                        }
                                    }
                                }, i * 150);
                            });
                        }
                    });
                });
            }
        }
    }

    var initScrollLibrary = function (element) {

        if (!moduleInitialized) {
            queue.push(element);

            if (!loadingStarted) {
                loadingStarted = true;
                itsoftApp.loadScript("/assets/scripts/gsap/gsap.min.js", function () {
                    itsoftApp.loadScript("/assets/scripts/gsap/ScrollTrigger.min.js", function () {
                        moduleInitialized = true;
                        while (queue.length > 0) {
                            initScrollActions(queue.shift());
                        }
                    });
                });
            }
        } else {
            initScrollActions(element);
        }
    };

    module.callback = initScrollLibrary;
});